import React from 'react';
import clsx from 'clsx';
import { makeStyles, lighten } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { capitalizeFirstLetter } from "../../utils/utils";

const useStyles = makeStyles({
    primary: {
        fontSize: 14,
        whiteSpace: 'nowrap'
    },
    primaryLight: {
        color: '#fff'
    },
    primaryDark: {
        color: '#031729'
    },
    primaryBold: {
        fontWeight: 700
    },
    primarySemiBold: {
        fontWeight: 500
    },
    
});

const OtherTopicsItem = ({ ranking, value, index, theme, percent }) => {
    const classes = useStyles();

    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
            <Box width="100%" pr={2}>
                <Box 
                    // width={ranking/3}
                    width={`${percent * 2}%`} 
                    borderColor={`${lighten(theme? '#1e354d': '#DADEE4', 0.1)}`} 
                    border={1} 
                    bgcolor={theme? "#19314a": '#EFF1F7'} 
                    py={0.3} px={1} my={0.2} 
                    borderRadius={3} 
                    key={index}
                >
                    <Typography
                        className={clsx(
                            theme ? classes.primaryLight: classes.primaryDark, 
                            classes.primary,
                            index === 1 ? classes.primaryBold: classes.primarySemiBold
                        )}
                    >
                        {value && capitalizeFirstLetter(value)}
                    </Typography>
                </Box>            
            </Box>
            <Box mr={5}>
                <Typography
                    className={clsx(
                        theme ? classes.primaryLight: classes.primaryDark, 
                        classes.primary,
                    )}
                >
                    {percent}%
                </Typography>
            </Box>
        </Box>

 
        // <Box 
        //     // width={ranking/3} 
        //     borderColor={`${lighten(theme? '#1e354d': '#DADEE4', 0.1)}`} 
        //     border={1} 
        //     bgcolor={theme? "#19314a": '#EFF1F7'} 
        //     py={0.3} px={1} my={0.2} 
        //     borderRadius={3} 
        //     key={index}
        // >
        //     <Typography
        //         className={clsx(
        //             theme ? classes.primaryLight: classes.primaryDark, 
        //             classes.primary,
        //             index === 1 ? classes.primaryBold: classes.primarySemiBold
        //         )}
        //     >
        //         {value}
        //     </Typography>
        // </Box>
    )
}

export default OtherTopicsItem;
